import MonthDatePicker from "components/Varios/DatePicker/MonthDatePicker";
import React, { useCallback, useEffect, useState } from "react";
import { Button, Col, Row, Table } from "react-bootstrap";
import { PaginationLink, PaginationItem, Pagination, Input, Label } from "reactstrap";
import { obtenerSolicitudesAp, obtenerSolicitudesRev, obtenerSolicitudesRP, ReversarSolicitudes, unidadesHistorica } from "./FunctionsHistorialSolicitudes";
import { AprobarSolicitudesHEDTO, solicitudesUnidad } from "../Revisar Solicitudes Horas Extras/typesAprobarSolicitudHE";
import { showAlert } from "../Parametros Horas Extras/Actividades/ActividadesHorasExtras";
import { ReactComponent as IconReversar } from "../../../../assets/icons/HorasExtras/Reversar.svg";
import { bool } from "prop-types";
import { boolean } from "yargs";
import ModalConfirmacion from "components/Varios/Modals/ModalConfirmacion";
import TableHistorialSolicitudes from "./TablaHistorialSolicitudesHE";
import ModalCargando from "components/Varios/ModalCargando";
import Cargando from "components/Varios/Cargando";
import Swal from "sweetalert2";



export function HistorialSolicitudesHE() {

    const [fechames, setfechames] = useState<Date | null>(new Date());
    const [solicitudesHistoricas, setsolicitudesHistoricas] = useState<AprobarSolicitudesHEDTO[] | null>(null);
    const [SolReversoMasivo, setSolReversoMasivo] = useState<AprobarSolicitudesHEDTO[] | null>(null);
    const [unidadesHisto, setunidadesHisto] = useState<solicitudesUnidad[] | null>(null);
    const [EstadoSol, setEstadoSol] = useState<string>("SA");
    const [idConsultar, setidConsultar] = useState<number | null>(null);
    const [tituloModal, settituloModal] = useState<string>("");

    const [sortColumn, setSortColumn] = useState<string | null>('');
    const [sortDirection, setSortDirection] = useState('asc');
    const [sortToggle, setSortToggle] = useState(false);
    const [loading, setloading] = useState<boolean>(false);
    const [modalloading, setmodalloading] = useState<boolean>(false);
    const [currentPage, setCurrentPage] = useState(1);
    const [searchTerm, setSearchTerm] = useState('');

    const ReversoMAsivo = ["FN", "FT", "FJ", "FF", "FA"]; // sujeto a si se ha creado el documento
    const fechaActual = new Date();

    useEffect(() => {
        if (EstadoSol == "SA" && fechames) {
            unidades(fechames, true);
            solicitudesReversar(fechames);
        }
        else if (EstadoSol == "SN" && fechames) {
            unidades(fechames, false);
            setSolReversoMasivo([]);
        }
    }, [EstadoSol, fechames])

    useEffect(() => {
        if (idConsultar && EstadoSol == "SA") {
            solicitudesAprobadas(fechames, idConsultar);
        }
        else if (idConsultar && EstadoSol == "SN") {
            solicitudesNegadas(fechames, idConsultar);
        }
    }, [idConsultar])

    useEffect(() => {
        handleSort("unidad");
    }, [])

    async function solicitudesReversar(fecha: Date | null) {
        if (fecha) {
            const mes = fecha.getMonth() + 1;
            const anio = fecha.getFullYear();

            const solReversar = await obtenerSolicitudesRev(mes, anio);
            if (solReversar.status == 200 && solReversar.dataResponse) {
                setSolReversoMasivo(solReversar.dataResponse)
            }
            else {
                setSolReversoMasivo([]);
                showAlert(typeof solReversar.errorMessage === 'string' ? solReversar.errorMessage : 'Error desconocido', false);
            }
        }
    }

    async function solicitudesAprobadas(fecha: Date | null, idEstructura: number) {
        setmodalloading(true);
        if (fecha) {
            const mes = fecha.getMonth() + 1;
            const anio = fecha.getFullYear();

            const solicitudesA = await obtenerSolicitudesAp(mes, anio, idEstructura);
            if (solicitudesA.status == 200 && solicitudesA.dataResponse) {
                setsolicitudesHistoricas(solicitudesA.dataResponse)
            }
            else {
                setsolicitudesHistoricas([]);
                showAlert(typeof solicitudesA.errorMessage === 'string' ? solicitudesA.errorMessage : 'Error desconocido', false);
            }
        }
        setmodalloading(false);
    }

    async function solicitudesNegadas(fecha: Date | null, idEstructura: number) {
        setmodalloading(true);
        if (fecha) {
            const mes = fecha.getMonth() + 1;
            const anio = fecha.getFullYear();

            const solicitudesR = await obtenerSolicitudesRP(mes, anio, idEstructura);
            if (solicitudesR.status == 200 && solicitudesR.dataResponse) {
                setsolicitudesHistoricas(solicitudesR.dataResponse)
            }
            else {
                setsolicitudesHistoricas([]);
                showAlert(typeof solicitudesR.errorMessage === 'string' ? solicitudesR.errorMessage : 'Error desconocido', false);
            }
        }
        setmodalloading(false);
    }

    async function unidades(fecha: Date | null, isAprobado: boolean) {
        setloading(true);
        if (fecha) {
            const mes = fecha.getMonth() + 1;
            const anio = fecha.getFullYear();

            const unidades = await unidadesHistorica(mes, anio, isAprobado);
            if (unidades.status == 200 && unidades.dataResponse) {
                setunidadesHisto(unidades.dataResponse)
            }
            else {
                setunidadesHisto([]);
                showAlert(typeof unidades.errorMessage === 'string' ? unidades.errorMessage : 'No ha sido posible obtener la información', false);
            }
        }
        setloading(false);
    }

    async function Reversar(solicitudes: AprobarSolicitudesHEDTO[] | null) {
        var seReversa = false;
        if (solicitudes) {
            solicitudes.map((s) => {
                if (ReversoMAsivo.includes(s.estado.trim())) {
                    seReversa = true;
                }
            })
            if (seReversa) {
                const texto = `<div class="custom-modal-content">
                                <p>¿Esta seguro que desea Reversar todas las solicitudes?</p>
                            </div>`;

                const result = await Swal.fire({
                    html: texto,
                    icon: 'warning',
                    showCancelButton: true,
                    confirmButtonText: 'Aceptar',
                    cancelButtonText: 'Cancelar',
                    reverseButtons: true,
                    customClass: {
                        cancelButton: 'btn-cancelar',
                        confirmButton: 'btn-aceptar',
                        popup: 'custom-popup'
                    },
                });

                if (result.isConfirmed) {
                    const solicitudesReversadas = await ReversarSolicitudes(solicitudes);
                    if (solicitudesReversadas.status == 200) {
                        showAlert("Se han reversado las solicitudes correctamente", true);
                        if (EstadoSol == "SA") {
                            unidades(fechames, true);
                        }
                        else if (EstadoSol == "SN") {
                            unidades(fechames, false);
                        }
                    }
                    else {
                        showAlert(typeof solicitudesReversadas.errorMessage === 'string' ? solicitudesReversadas.errorMessage : 'Ha ocurrido un inconveniente al reversar las solicitudes', false);
                    }
                } else if (result.isDismissed && result.dismiss === Swal.DismissReason.cancel) {
                    console.log("Se negó la acción.");
                } else {
                    console.log("El modal fue cerrado sin realizar una acción.");
                    return;
                }
            }
            else {
                showAlert("No es posible reversar el proceso", false);
            }
        }
        return 1;
    }

    async function aceptar() {
        setidConsultar(null);
        return 1;
    }

    const actualizar = async () => {
        if (idConsultar != null && EstadoSol == "SA") {
            solicitudesAprobadas(fechames, idConsultar);
            unidades(fechames, true);
        }
        else if (idConsultar != null && EstadoSol == "SN") {
            solicitudesNegadas(fechames, idConsultar);
            unidades(fechames, false);
        }
    };

    const handleSort = (column) => {
        const isAsc = sortColumn === column && sortDirection === 'asc';
        setSortColumn(column);
        setSortDirection(isAsc ? 'desc' : 'asc');
        setSortToggle(!sortToggle); // Cambia el estado para forzar re-render
    };

    const applySorting = (data) => {
        if (!sortColumn) return data;

        if (data) {
            const sortedData = [...data].sort((a, b) => {
                if (a && b) {
                    var valA = a[sortColumn];
                    var valB = b[sortColumn];

                    if (typeof valA === "string" && typeof valB === "string") {
                        // Sort strings using localeCompare
                        return valA.localeCompare(valB) * (sortDirection === 'asc' ? 1 : -1);
                    } else if (typeof valA === "number" && typeof valB === "number") {
                        // Sort numbers directly
                        return (valA - valB) * (sortDirection === 'asc' ? 1 : -1);
                    }
                    // Handle potential cases where types are mixed or unexpected
                    return 0;
                }
                return 0;
            });
            return sortedData;
        }
    };

    const handleSearchChange = (event: React.ChangeEvent<HTMLInputElement>) => {
        setSearchTerm(event.target.value);
        setCurrentPage(1); // Reiniciar la paginación cuando se busca
    };
    //filtrado para el buscador
    const filteredSolicitudes = unidadesHisto?.filter(solic =>
        (solic.unidad.toLowerCase().includes(searchTerm.toLowerCase()))
    );

    const sortedSolicitudes = applySorting(filteredSolicitudes);

    const contenidoHistorico = useCallback(() => {
        if (solicitudesHistoricas && fechames) {
            return (
                <React.Fragment>
                    <TableHistorialSolicitudes
                        contenido={solicitudesHistoricas}
                        mes={fechames.getMonth() + 1}
                        actualizar={actualizar}
                    />
                </React.Fragment>
            );
        }

    }, [solicitudesHistoricas])

    const contenidoTablas = useCallback(() => {
        return (
            <>
                <Row className="d-flex justify-content-start">
                    <Col md="3">
                        <Input
                            type="text"
                            placeholder="Buscar..."
                            value={searchTerm}
                            onChange={handleSearchChange}
                            className="form-control-sm" // Reduce el tamaño del input
                        />
                    </Col>
                </Row>
                {SolReversoMasivo && SolReversoMasivo.length > 0 && ReversoMAsivo.includes(SolReversoMasivo[0].estado.trim()) && (fechames?.getMonth()) == fechaActual.getMonth() && fechames.getFullYear() == fechaActual.getFullYear() &&
                    <Row style={{ marginTop: -50 }} className="d-flex justify-content-end">
                        <Col md={3}>
                            <Button onClick={() => {
                                Reversar(SolReversoMasivo);
                            }}
                                className="btn-white-red">
                                <div className="containerBtnReversoProyTH">
                                    <div> Reversar Todo</div>
                                    <IconReversar className="iconBotonImprimir" />
                                </div>
                            </Button>
                        </Col>
                    </Row>
                }
                {sortedSolicitudes.length < 1 && (
                    <Label className={"font-15"}>
                        No Existen solicitudes para las fechas seleccionadas
                    </Label>
                )}
                {sortedSolicitudes.length > 0 && (
                    <div className="table-responsive">
                        <Table>
                            <thead className="cabeceras_tabla_solicitudes_he">
                                <tr>
                                    <th colSpan={1} style={{ textAlign: "left" }} onClick={() => handleSort("unidad")}> Unidad</th>
                                    {EstadoSol == "SA" && <th colSpan={1} style={{ textAlign: "center" }}> #Solicitudes <br /> Aprobadas</th>}
                                    {EstadoSol == "SN" && <th colSpan={1} style={{ textAlign: "center" }}> #Solicitudes <br /> Negadas</th>}
                                </tr>
                            </thead>
                            {sortedSolicitudes.map((su, i) => {
                                return (
                                    <React.Fragment key={i}>
                                        <tbody className="table_solicitudes_he">
                                            <tr className='rows_tabla_solicitudes_he' onClick={() => {
                                                setidConsultar(su.idEstructuraOrg);
                                                settituloModal(su.unidad);
                                            }}>
                                                <td align="left"> {su.unidad} </td>
                                                {EstadoSol == "SA" && <td align="center"> {su.solicitudesAP} </td>}
                                                {EstadoSol == "SN" && <td align="center"> {su.solicitudesPA} </td>}
                                            </tr>
                                        </tbody>
                                    </React.Fragment>
                                )
                            })}
                        </Table>
                    </div>
                )}
            </>
        );
    }, [sortedSolicitudes])

    return (
        <React.Fragment>
            <div className="content">
                <div className="titulo_seccion"> HISTORIAL SOLICITUDES </div>
                <br></br>
                <label> Seleccione mes y año:</label>
                <Row className="d-flex justify-content-start">
                    <Col xl={2}>
                        <MonthDatePicker
                            value={fechames}
                            color="blue"
                            placeholderText="Seleccione fecha"
                            onChange={(e) => setfechames(e)}
                        />
                    </Col>
                    {fechames != null &&
                        <Col>
                            <select className="custom-select" onChange={(e) => setEstadoSol(e.target.value)}>
                                <option value={"SA"}> Solicitudes Aprobadas </option>
                                <option value={"SN"}> Solicitudes Negadas </option>
                            </select>
                        </Col>
                    }
                </Row>
                <br></br>
                {
                    loading && <Cargando />
                }
                {!loading && EstadoSol != null && unidadesHisto != null &&
                    contenidoTablas()
                }

            </div>
            <ModalCargando
                show={modalloading != false}
                onClose={() => setmodalloading(false)}
                textoCargando='Cargando Datos'
                size='md'
            />

            <ModalConfirmacion
                idModal="ModalEditarActividadHE"

                show={idConsultar != null && loading != true}
                size='xl'
                centered={true}
                asyncAccion={true}
                asyncClose={false}
                closeAfterAccion={true}
                hideBotonCerrar={true}
                // nam
                mensajeConfirmacion=''
                nombreBotonAccion='Aceptar'
                nombreBotonCerrarModal='Cancelar'
                classNameBotonAccion='mr-2 btnEspolPrimary btn btn-primary'
                classNameBotonCerrarModal2='btn-white-red btn btn-secondary'
                onClose={() => setidConsultar(null)}
                asyncOnClick={async () => await aceptar()}
                contentModal={contenidoHistorico()}
                tituloModal={tituloModal}
                classNameContainer="containerModalRevision"
                useContainer={true}
            />

        </React.Fragment>
    )
}

